import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { SuccessDialogConfig, MeSuccessComponent } from './me-success.component';
import { TranslateService } from '@ngx-translate/core';
import { BackPriority, NavigationService } from 'src/app/system/utility/navigation.service';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';

@Injectable({
    providedIn: 'root'
})
export class MeSuccessDialogService {

    private dialogRef!: MatDialogRef<MeSuccessComponent, null>;

    constructor(
        private srvDialog: MatDialog,
        private translate: TranslateService,
        private srvNav: NavigationService,
        private srvRpDesign: ResponsiveDesignService) {
    }

    private readonly setDialogConfig = (data: SuccessDialogConfig) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = data;
        dialogConfig.maxWidth = 600;
        dialogConfig.width = '98%';
        dialogConfig.height = 'auto';
        dialogConfig.panelClass = 'custom-dialog-success-messages';
        return dialogConfig;
    };

    public show(title: string, message: string | string[], buttonText: string | null = null): Observable<null | undefined> {
        let config: SuccessDialogConfig = {
            title: title,
            message: message,
            buttonText: buttonText ?? this.translate.instant('BUTTON_DONE')
        }
        return this.showDialog(config);
    }

    /**
     * Show a success dialog that closes automatically after {@link autoCloseMs} (no button).
     */
    public showAutoClose(title: string, message: string | string[], autoCloseMs: number = 2000): Observable<null | undefined> {
        const config: SuccessDialogConfig = {
            title,
            message,
            buttonText: null,
            autoCloseMs,
        };
        return this.showDialog(config);
    }

    public showDialog(config: SuccessDialogConfig): Observable<null | undefined> {
        // Close the previous dialog if exist
        if ((this.dialogRef) && (this.dialogRef.getState() == MatDialogState.OPEN)) {
            this.dialogRef.close();
        }

        this.dialogRef = this.srvDialog.open(MeSuccessComponent, this.setDialogConfig(config));

        if (this.srvRpDesign.isMobileAndroid()) {
            const unregister = this.srvNav.registerBackHandler(
                BackPriority.DIALOG,
                () => {
                    if (this.dialogRef?.getState() !== MatDialogState.OPEN) {
                        return of(false);
                    }
                    this.dialogRef.close();
                    return of(true);
                },
                'dialog:me-success'
            );
            this.dialogRef.afterClosed().subscribe(() => unregister());
        }

        return this.dialogRef.afterClosed();
    }
}
